import { render, staticRenderFns } from "./PageCreateEge.vue?vue&type=template&id=74027e13&scoped=true"
import script from "./PageCreateEge.vue?vue&type=script&lang=js"
export * from "./PageCreateEge.vue?vue&type=script&lang=js"
import style0 from "./PageCreateEge.vue?vue&type=style&index=0&id=74027e13&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74027e13",
  null
  
)

export default component.exports